/* =========================================================
 * MONOC site.json ⇔ Shopifyテーマ 接続レイヤー
 * 仕様: SITE-INTEGRATION.md (schema: monoc.site/v1)
 *
 * 役割分担(ハイブリッド):
 *   Shopify  = 商品マスタ(商品名・価格・在庫・画像・カート・決済)
 *   site.json = キュレーション層(掲載可否・並び順・注目枠・人気順・availability表示)
 *
 * 設計方針: プログレシブエンハンスメント。
 *   サーバ側(Liquid)はShopifyの既定順で描画済み。このJSが後から並べ替え・除外・
 *   バッジ付与を行う。site.json が読めなければ何もしない = ページは落ちない(仕様書3.4-5)。
 *
 * 紐付けキーは SKU。product-card / 商品ページに data-sku を出力している(仕様書§2)。
 * ========================================================= */
(function () {
  "use strict";

  var cfg = window.MONOC_SITE_CONFIG || {};
  if (!window.MonocSite) return;

  /* availability ごとの表示ルール(仕様書 3.3) */
  var AVAIL = {
    in_stock:     { badge: null,       cls: "",     buyable: true,  listed: true },
    low_stock:    { badge: "残りわずか", cls: "low",  buyable: true,  listed: true },
    out_of_stock: { badge: "在庫切れ",   cls: "out",  buyable: false, listed: true },
    coming_soon:  { badge: "近日発売",   cls: "soon", buyable: false, listed: true },
    discontinued: { badge: "販売終了",   cls: "end",  buyable: false, listed: false },
    unavailable:  { badge: null,       cls: "",     buyable: false, listed: false }
  };

  function rule(a) { return AVAIL[a] || AVAIL.in_stock; }

  function skuOf(el) { return (el.getAttribute("data-sku") || "").trim(); }

  /* ---------- 一覧の並べ替え・除外・バッジ ---------- */
  function applyGrid(grid, site) {
    var mode = grid.getAttribute("data-monoc-grid") || "items";
    var list = mode === "popular" ? site.popular() : site.items();
    var rank = {};
    list.forEach(function (it, idx) { rank[it.sku] = idx; });

    var cards = [].slice.call(grid.querySelectorAll("[data-sku]"));
    if (!cards.length) return;

    cards.forEach(function (card) {
      var sku = skuOf(card);
      var item = sku ? site.bySku(sku) : null;

      /* site.json に無い商品 */
      if (!item) {
        if (cfg.hideUnlisted) card.remove();
        else card.style.order = 9000;           /* 末尾へ回す */
        return;
      }
      var r = rule(item.availability);

      /* discontinued / unavailable は一覧から外す(仕様書 3.3) */
      if (!r.listed) { card.remove(); return; }

      card.style.order = (rank[sku] == null ? 8000 : rank[sku]);
      if (item.featured) card.setAttribute("data-monoc-featured", "1");
      paintBadge(card, r);
      if (!r.buyable) card.setAttribute("data-monoc-unbuyable", "1");
    });

    /* order を効かせるため flex 化(グリッドのままだと order が使えないケースがある) */
    grid.setAttribute("data-monoc-ordered", "1");
  }

  function paintBadge(scope, r) {
    if (!r.badge) return;
    if (scope.querySelector(".monoc-badge")) return;
    var host = scope.querySelector("[data-monoc-badge-slot]") || scope;
    var b = document.createElement("span");
    b.className = "monoc-badge " + r.cls;
    b.textContent = r.badge;
    host.insertBefore(b, host.firstChild);
  }

  /* ---------- 注目枠 ---------- */
  function applyFeatured(box, site) {
    var feat = site.featured();
    var skus = {};
    feat.forEach(function (i) { skus[i.sku] = true; });
    var cards = [].slice.call(box.querySelectorAll("[data-sku]"));
    var shown = 0;
    cards.forEach(function (card) {
      if (skus[skuOf(card)]) { shown++; } else { card.remove(); }
    });
    /* 0件でも崩れないように、枠ごと畳む(仕様書 3.4-3) */
    if (shown === 0) box.setAttribute("hidden", "hidden");
  }

  /* ---------- 商品ページ ----------
   * SKUは theme.liquid が MONOC_SITE_CONFIG.productSku に出力しています */
  function applyProduct(site) {
    var root = document.querySelector(".pd");
    if (!root || !cfg.productSku) return;
    var item = site.bySku(cfg.productSku);
    if (!item) return;
    var r = rule(item.availability);

    /* 商品ページのバッジは .pd-info に置く(関連商品カードに紛れ込ませない) */
    var info = root.querySelector(".pd-info");
    if (info && r.badge && !info.querySelector(".monoc-badge")) {
      var b = document.createElement("span");
      b.className = "monoc-badge " + r.cls;
      b.textContent = r.badge;
      info.insertBefore(b, info.firstChild);
    }

    if (!r.buyable) {
      var form = root.querySelector("form[action*='/cart/add']");
      if (form) {
        var btn = form.querySelector("button[type=submit]");
        if (btn) {
          btn.disabled = true;
          btn.style.opacity = ".45";
          btn.style.cursor = "not-allowed";
          if (item.availability === "coming_soon") btn.textContent = "近日発売";
          else btn.textContent = "在庫切れ";
        }
      }
      /* 在庫切れのときだけ「入荷お知らせ」へ誘導(仕様書 3.3) */
      if (item.availability === "out_of_stock" && cfg.restockUrl) {
        var cta = root.querySelector(".pd-cta");
        if (cta && !cta.querySelector(".monoc-restock")) {
          var a = document.createElement("a");
          a.className = "btn-o monoc-restock";
          a.href = cfg.restockUrl;
          a.textContent = "入荷お知らせを受け取る";
          cta.appendChild(a);
        }
      }
    }

    /* 販売終了は「販売終了」表示に切り替える(直リンク対策・仕様書 3.3) */
    if (item.availability === "discontinued") {
      var cta2 = root.querySelector(".pd-cta");
      if (cta2) cta2.innerHTML = '<p class="monoc-ended">この商品は販売を終了しました。</p>';
    }
  }

  /* ---------- 起動 ---------- */
  MonocSite.load(cfg.url, { ttl: cfg.ttl }).then(function (site) {
    /* live 以外は noindex(仕様書 3.4-4) */
    site.applyRobots();

    /* 掲載商品が1件も無い(＝取得失敗で空データ)なら、Shopifyの既定表示のまま何もしない */
    if (!site.items().length) return;

    [].slice.call(document.querySelectorAll("[data-monoc-grid]")).forEach(function (g) {
      try { applyGrid(g, site); } catch (e) { }
    });
    [].slice.call(document.querySelectorAll("[data-monoc-featured-box]")).forEach(function (b) {
      try { applyFeatured(b, site); } catch (e) { }
    });
    try { applyProduct(site); } catch (e) { }

    if (cfg.debug && window.console) {
      console.log("[MONOC] site.json", site.meta(), site.loadedFrom);
    }
  });
})();
